/**
 * Created by wangqian on 2017/5/14.
 */
$(function () {
  var __ddHFCommon = {
    //获取站点标准，顺序如下
    //1.判断window的__site变量
    //2.url的参数中的site字段
    //3.url最后位
    //现有的site有feature（产品），caselist（案例），dd-server（服务），summit（ding峰会），download（下载）
    getParam: function () {
      if (window.__site) {
        return window.__site;
      }
      var url = window.location.href;

      if (url.indexOf('?') == -1 || url.indexOf('site=') == -1) {
        var fullUrl = url.split('?')[0],
          siteUrl = fullUrl.substring(fullUrl.lastIndexOf('/') + 1).split('.')[0].split('#')[0];
        if (siteUrl.indexOf('case') > -1 && siteUrl != 'industry_case_sem_pc') {
          siteUrl = 'caselist';
        }
        return siteUrl;
      }

      var params = url.split('?')[1].split('&');
      for (var i = 0, len = params.length; i < len; i++) {
        if (params[i].split('=')[0] == 'site') {
          return params[i].split('=')[1];
        }
      }

      return '';
    },
    init: function () {
      //根据url、参数等增加选中效果
      var site = this.getParam(),
        siteClass;
      switch (site){
        case 'communicate':
        case 'conference':
        case 'mobile':
        case 'device':
        case 'dingtalksecurity':
        case 'productding':
        case 'producthrm':
        case 'productdingdrive':
        case 'feature':siteClass='feature';break;
        case 'industry_case_sem_pc':siteClass='industryCase';break;
        case 'caselist':siteClass='caselist';break;
        case 'dd-server':siteClass='dd-server';break;
        case 'summit':siteClass='summit';break;
        case 'download':siteClass='download';break;
        case 'dingding-smartDevice_pc':siteClass='aideviceNew';break;
        case 'cooperativepartner':siteClass='partner';break;
        default:
      }
      if (siteClass != '') {
        $('.dd-navbar .' + siteClass).addClass('link-active');
      }
      //微信公众号展示
      $('#weixin-icon').on('mouseenter', function () {
        $('#weixin-qrcode').show();
      }).on('mouseleave', function () {
        $('#weixin-qrcode').hide();
      });

      // //下拉增加fixed样式
      // $(window).scroll(function () {
      //   var scrollTop = $(document).scrollTop();
      //   if (scrollTop > 100) {
      //     $('#dd-navbar').addClass('dd-navbar-fixed');
      //   } else {
      //     $('#dd-navbar').removeClass('dd-navbar-fixed');
      //   }
      // });

      if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE8.0") {
        $('.dd-footer .dd-footer-content .link,.weibo,.bottom .friend a').css('color', '#fff');
      }

      // //智能硬件展示和隐藏
      // var hideFunc = function () {
      //   setTimeout(function () {
      //     if(self._deviceHide){
      //       $('.dd-navbar-device').fadeOut(200);
      //     }else {
      //       hideFunc();
      //     }
      //   },50);
      // };
      // $('.aidevice').on('mouseover',function () {
      //   self._deviceHide = false;
      //   $('.dd-navbar-device').fadeIn(200);
      // });
      // $('.dd-navbar-device').on('mouseover',function () {
      //   self._deviceHide = false;
      // });
      // $('.dd-navbar-device').on('mouseout',function () {
      //   self._deviceHide = true;
      // });
      // $('.aidevice').on('mouseout',function () {
      //   self._deviceHide = true;
      //   hideFunc();
      // });
    }
  };

  __ddHFCommon.init();

})




//////////////////
// WEBPACK FOOTER
// ./app/js/commonHF.page.js
// module id = 0
// module chunks = 7